import authAxios from "../authAxios";

// Get all campaign details by slug (including trips and user referral status if authenticated)
export const getCampaignDetailsBySlug = (campaignSlug) => {
  return authAxios.get(`/v1/campaign/${campaignSlug}/details`);
};
